import React from 'react';

const fileStyle = {
  position: 'absolute',
  width: '100%',
  padding: '24px 100px',
  top: '0px',
  left: '0px',
  height: '94px',
  display: 'none',
  cursor: 'pointer',
  /* //영역은 있지만 투명하게 (드래그앤드롭하려고 넣음)
  opacity: 0;
  filter: alpha(opacity=0); */
};

const FileInput = ({ fileRef, fileHandler, accept = 'all', multiple = 'disabled' }) => (
  <input
    ref={fileRef}
    type="file"
    className="fileInput"
    style={fileStyle}
    value={''}
    onChange={e => fileHandler(e)}
    accept={accept}
    multiple={multiple}
  />
);

export default FileInput;
